import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

import Index from "views/Index.js";
import NotFound from "components/Own/404/NotFound";
import Terms from "views/Terms";

import Feed from "views/Feed";
import Privacy from "views/Privacy";


function App() {

    return (
        <Routes>
            {/* add routes without layouts */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/discover" element={<Feed />} />
            <Route path="/" element={<Index />} />
            <Route path="/404" element={<NotFound />} />
        </Routes>
    );
}

export default App;